<template>
  <div class="activity-box">
    <div class="main">
      <img class="bg" src="./images/bg.png" alt="" />
      <div class="progress-box">
        <div class="value" :style="{ width: lastHpWidth }"></div>
        <span class="hp-text">當前血量：{{ hp }}</span>
      </div>
      <div class="video-box">
        <video
          data-v-c4afa4bc=""
          src="./images/dragon.mp4"
          autoplay="autoplay"
          loop="loop"
          muted="muted"
          class="banner-item banner-video"
          style="width: 913px; height: 627px;"
        ></video>
      </div>
      <img
        class="tab"
        src="./images/tab1-active.jpg"
        alt=""
        v-show="activeIndex === 1"
        @click="checkScoreList(1)"
      />
      <img
        class="tab"
        src="./images/tab1.jpg"
        alt=""
        v-show="activeIndex === 2"
        @click="checkScoreList(1)"
      />
      <img
        class="tab2"
        src="./images/tab2.jpg"
        alt=""
        v-show="activeIndex === 1"
        @click="checkScoreList(2)"
      />
      <img
        class="tab2"
        src="./images/tab2-active.jpg"
        alt=""
        v-show="activeIndex === 2"
        @click="checkScoreList(2)"
      />
      <div class="total-prize">{{ pool || 0 }}</div>
      <div class="damage">{{ score || 0 }}</div>
      <div class="ranking">{{ userRank || '---' }}</div>
      <div class="previous" @click="getPrevious()" v-if="batch > 1">上一條</div>
      <div class="next" @click="getNext()" v-if="batch < nowBatch">下一條</div>
      <div class="top3-box" v-show="activeIndex === 1">
        <div
          v-for="(item, index) of userTopList"
          :key="item.userUuid"
          class="item"
          :class="`top${index + 1}`"
          @click="toPlayerDetail(item.userUuid)"
        >
          <template v-if="item && item.userUuid">
            <img :src="item.avatarUrl" class="head-portrait" />
            <div class="user-name">{{ item.nickname }}</div>
            <div class="score">{{ item.score }}</div>
          </template>
        </div>
      </div>
      <div class="score-board-box" v-show="activeIndex === 1">
        <div
          class="item"
          v-for="(item, i) of userList.slice(3, 10)"
          :key="item.userUuid"
          :class="`item${i + 3}`"
          @click="toPlayerDetail(item.userUuid)"
        >
          <template v-if="item && item.userUuid">
            <div class="left">
              <img :src="item.avatarUrl" alt="排名頭像" class="" />
              <span class="user-name">{{ item.nickname }}</span>
            </div>
            <div class="right">
              <span class="scroe">傷害{{ item.score || '--' }}</span>
            </div>
          </template>
        </div>
      </div>
      <div class="top3-box" v-show="activeIndex === 2">
        <div
          v-for="(item, index) of voiceRoomTopList"
          :key="item.userUuid"
          class="item"
          :class="`top${index + 1}`"
          @click="toVoiceRoom(item.userUuid)"
        >
          <template v-if="item && item.userUuid">
            <img :src="item.avatarUrl" class="head-portrait" />
            <div class="user-name">{{ item.nickname }}</div>
            <div class="score">{{ item.score }}</div>
          </template>
        </div>
      </div>
      <div class="score-board-box" v-show="activeIndex === 2">
        <div
          class="item"
          v-for="(item, i) of voiceRoomList.slice(3, 10)"
          :key="item.userUuid"
          :class="`item${i + 3}`"
          @click="toVoiceRoom(item.userUuid)"
        >
          <template v-if="item && item.userUuid">
            <div class="left">
              <img :src="item.avatarUrl" alt="排名頭像" class="" />
              <span class="user-name">{{ item.nickname }}</span>
            </div>
            <div class="right">
              <span class="scroe">傷害{{ item.score || '--' }}</span>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SlayingDragons',
  data() {
    return {
      userList: [],
      voiceRoomList: [],
      activeIndex: 1,
      pool: 0,
      score: 0,
      userRank: 0,
      batch: 0,
      nowBatch: 0, //当前正进行的屠龙活动批次
      hp: 0,
      totalHp: 0,
      loading: false
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    uuid() {
      return this.userInfo ? this.userInfo.uuid : '';
    },
    userTopList() {
      return this.userList && this.userList.length
        ? [this.userList[1], this.userList[0], this.userList[2]]
        : [{}, {}, {}];
    },
    voiceRoomTopList() {
      return this.voiceRoomList && this.voiceRoomList.length
        ? [this.voiceRoomList[1], this.voiceRoomList[0], this.voiceRoomList[2]]
        : [{}, {}, {}];
    },
    lastHpWidth() {
      if (this.hp != undefined && this.totalHp) {
        return this.hp > 0
          ? `calc(${((this.totalHp - this.hp) / this.totalHp) * 100}%)`
          : 0;
      } else {
        return 0;
      }
    }
  },
  watch: {
    uuid: {
      handler: function(val) {
        if (val) {
          this.getDetail(val);
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async getDetail() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      try {
        const { data } = await this.$http.get('/activity/dragonInfo', {
          batch: this.batch
        });
        if (data) {
          this.score = data.score;
          this.userRank = data.rank;
          this.pool = data.pool;
          this.hp = data.hp;
          this.userList = data.userRank;
          this.voiceRoomList = data.roomRank;
          this.totalHp = data.hpTotal;
          for (let i = 0; i < 10; i++) {
            if (!this.userList[i]) {
              this.userList[i] = {};
            }
            if (!this.voiceRoomList[i]) {
              this.voiceRoomList[i] = {};
            }
          }
          this.nowBatch = this.batch === 0 ? data.batch : this.nowBatch;
          this.batch = data.batch;
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    toPlayerDetail(userUuid) {
      this.$router.push({
        path: `/player-detail/${userUuid}`
      });
    },
    checkScoreList(index) {
      this.activeIndex = index;
    },
    getPrevious() {
      if (this.loading) {
        return;
      } else {
        if (this.batch > 1) {
          this.batch -= 1;
          this.getDetail();
        }
      }
    },
    getNext() {
      if (this.loading) {
        return;
      } else {
        if (this.batch < this.nowBatch) {
          this.batch += 1;
          this.getDetail();
        } else {
          this.$message('下一條龍還未降臨！');
        }
      }
    },
    toVoiceRoom(roomUid) {
      window.open(`/voice-room/${roomUid}`, '_blank');
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.activity-box {
  width: 100%;
  background-color: #0d102f;
  overflow: auto;
  text-align: center;
  .main {
    position: relative;
    display: inline-block;
    width: 980px;
    text-align: left;
    > .bg {
      width: 100%;
    }
    .total-prize {
      position: absolute;
      top: 1618px;
      left: 470px;
      font-size: 48px;
      color: #1b67e5;
      width: 174px;
      text-align: center;
    }
    .damage {
      position: absolute;
      top: 1796px;
      color: #271b6a;
      left: 290px;
      font-size: 40px;
    }
    .ranking {
      position: absolute;
      top: 1796px;
      color: #271b6a;
      left: 738px;
      font-size: 40px;
    }
    .tab,
    .tab2 {
      position: absolute;
      top: 1923px;
      width: 405px;
      height: auto;
    }
    .tab {
      left: 80px;
    }
    .tab2 {
      right: 80px;
    }
    .top3-box {
      position: absolute;
      top: 2215px;
      display: flex;
      left: 67px;
      justify-content: space-around;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 24px;
        flex: none;
        color: #fffde4;
        width: 232px;
        img {
          border-radius: 50%;
          object-fit: cover;
          width: 214px;
          height: 214px;
        }
        .user-name,
        .score {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          width: 100%;
          text-align: center;
          opacity: 0.9;
          font-weight: 400;
        }
        .user-name {
          margin-top: 120px;
          font-weight: bold;
          font-size: 42px;
          color: white;
        }
        .score {
          margin-top: dPx(5);
          font-size: 24px;
          opacity: 0.9;
          font-weight: 400;
          color: white;
        }
        &.top1 {
          margin-right: 63px;
        }
        &.top2 {
          width: 250px;
        }
        &.top1,
        &.top3 {
          margin-top: 149px;
        }
        &.top2 {
          margin-right: 65px;
          img {
            width: 228px;
            height: 228px;
          }
        }
      }
    }
    .score-board-box {
      position: absolute;
      top: 2931px;
      left: 74px;
      width: 832px;
      overflow: auto;
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
      &::-webkit-scrollbar {
        display: none;
      }
      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 190px;
        font-size: 28px;
        margin-bottom: 41px;
        color: #1b67e5;
        border-radius: 40px;
        padding: 0 40px 0 52px;
        // &.item8 {
        //   height: 180px;
        //   margin-bottom: 23px;
        // }
        .left,
        .right {
          display: flex;
          align-items: center;
        }
        .right {
          margin-left: 30px;
        }
        .left {
          .index {
            margin-left: dPx(24);
            margin-right: 88px;
            width: 30px;
            text-align: right;
          }
          img {
            width: 130px;
            height: 130px;
            border-radius: 50%;
            margin-right: dPx(26);
            object-fit: cover;
          }
          .user-name {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            width: 284px;
            font-weight: bold;
          }
        }
        .right {
          img {
            width: 36px;
            margin: 0 0 0 14px;
          }
        }
      }
    }
  }
  .video-box {
    position: absolute;
    top: 945px;
    height: 562px;
    overflow: hidden;
    width: 910px;
    left: 35px;
    border-radius: 28px;
  }
  .progress-box {
    position: absolute;
    top: 857px;
    height: 35px;
    width: 939px;
    left: 24px;
    border-radius: 23px;
    background: linear-gradient(to right, #2bfb29, #fe0700);
    overflow: hidden;
    .hp-text {
      color: white;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 3;
    }
    .value {
      background-color: #0c1130;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
    }
  }
  .previous,
  .next {
    position: absolute;
    top: 2166px;
    width: 100px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid white;
    color: white;
    border-radius: 20px;
    cursor: pointer;
  }
  .previous {
    left: 144px;
  }
  .next {
    right: 130px;
  }
}
</style>
